module.exports = __webpack_public_path__ + "static/img/mlogo.1d930cef.png";